const MOUNTING_TYPES: string[] = ['Aerial', 'ROE', 'SMB'];

export const MOUNTING_TYPES_WITH_VALUES = [
  { label: 'Strand', value: 'Aerial' },
  { label: 'Macro', value: 'ROE' },
  { label: 'SMB', value: 'SMB' },
];

export default MOUNTING_TYPES;
